import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { DEFAULT_THEME, ACCENT_THEMES } from "./themes";

const ThemeContext = createContext(null);
const MODE_KEY = "kaos_mode";
const THEME_KEY = "kaos_theme";

const getInitialMode = () => {
  try {
    const saved = localStorage.getItem(MODE_KEY);
    if (saved === "light" || saved === "dark") return saved;
    return window.matchMedia && window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  } catch (e) {
    return "dark";
  }
};

const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem(THEME_KEY);
    return ACCENT_THEMES.some((t) => t.id === saved) ? saved : DEFAULT_THEME;
  } catch (e) {
    return DEFAULT_THEME;
  }
};

export const ThemeProvider = ({ children }) => {
  const [mode, setMode] = useState(getInitialMode);
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    document.documentElement.setAttribute("data-mode", mode);
    try { localStorage.setItem(MODE_KEY, mode); } catch (e) {}
  }, [mode]);

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try { localStorage.setItem(THEME_KEY, theme); } catch (e) {}
  }, [theme]);

  const toggleMode = useCallback(() => setMode((m) => (m === "dark" ? "light" : "dark")), []);

  return (
    <ThemeContext.Provider value={{ mode, theme, setTheme, toggleMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
